import { lazyLoadComponentFactory } from "@Components/Modules/Helpers";

export type { IAdTag } from "./AdTag";

export default lazyLoadComponentFactory(() => import(/* webpackChunkName: "ad-tag" */ "./AdTag"));
